export const IVA = 0.19;

export const IMAGE_MAX_WIDTH = 500;
export const IMAGE_MAX_HEIGHT = 700;